import { LocationPicker } from "../LocationPicker";
import { BarterForSelect } from "../BarterForSelect";
import { CategorySelect } from "../CategorySelect";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";

export const TitleSection = ({ value, onChange, error }) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="title">
        Title <span className="text-red-500">*</span>
      </Label>
      <Input
        id="title"
        placeholder="Fresh Tomatoes from my Garden"
        value={value}
        onChange={onChange}
      />
      {error && <p className="text-sm text-red-600">{error}</p>}
    </div>
  );
};

export const DescriptionSection = ({ value, onChange, error }) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="description">
        Description <span className="text-red-500">*</span>
      </Label>
      <Textarea
        id="description"
        placeholder="Describe your homegrown food, when it was harvested, and what you might be looking to trade for..."
        value={value}
        onChange={onChange}
      />
      {error && <p className="text-sm text-red-600">{error}</p>}
    </div>
  );
};

export const CategorySection = ({ value, onChange, error }) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="category">
        Category <span className="text-red-500">*</span>
      </Label>
      <CategorySelect value={value} onChange={onChange} error={error} />
      {error && <p className="text-sm text-red-600">{error}</p>}
    </div>
  );
};

/**
 * Edit-mode location section. Simpler than the create version — the listing
 * already has a location, so we just show the picker pre-populated with it.
 * No "use profile location" toggle here, because at edit time the listing's
 * own location is what matters.
 */
export const LocationSection = ({ value, onChange, error }) => {
  return (
    <div className="space-y-2">
      <Label>
        Location <span className="text-red-500">*</span>
      </Label>
      <LocationPicker
        value={value}
        onChange={onChange}
        countryCode="ZA"
        error={error}
        placeholder="Change this listing's location..."
      />
      {error && <p className="text-sm text-red-600">{error}</p>}
    </div>
  );
};

export const BarterForSection = ({ value, onChange, error }) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="barterFor">Barter For</Label>
      <BarterForSelect value={value} onChange={onChange} error={error} />
    </div>
  );
};